import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const facebook11Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'facebook_image_11',
  aspectRatio: 1,
  type: 'Image1x1',
  associationType: 'SquareImageMedia',
  imagePreviewHeight: 266,
  minimumRequirements: 0,
  minSize: [300, 300],
  hideHeaderButtons: true,
  localizedText: {
    previewTypeStringKey: _TL_('Facebook'),
    stringKey: _TL_('1 : 1'),
    disclaimerMessage: _TL_('This is an example of how your ad could appear on other websites on the Microsoft Advertising Network. The final ad format is likely to change to match the look and feel of the website.'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: false,
    showBusinessName: false,
    showImage: true,
    showShortHeadline: true,
    showShortHeadlineMultiline: false,
    showDescription: true,
    showUrl: true,
    showPersonaDecorator: true,
  },
  styleOverrides: {
    previewContent: {
      border: '0.5px solid #ddd',
      width: '266px',
      minHeight: '372px',
      padding: 0,
    },
    textContainer: {
      position: 'relative',
      padding: '8px',
      background: '#f0f2f5',
      minHeight: '60px',
    },
    shortHeadline: {
      marginTop: '16px',
      overflow: 'hidden',
      maxHeight: '48px',
      fontSize: '12px',
      fontWeight: 600,
      color: '#000000',
    },
    finalUrl: {
      position: 'absolute',
      top: '6px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '250px',
      height: '16px',
      fontSize: '10px',
      color: '#53565C',
    },
    description: {
      fontSize: '12px',
      color: '#333',
    },
  },
};

export default facebook11Raw;
